module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAO1JREFUOE+907tKA0EUBuD/n4exSWFjlcYiVQrd3creRuwCIZmIXapd9wnS2QVBYZZNigRCHiCFvo84R7ZTyM7FLE57ho9zJTp+7NjD/4GS6g9AxjRPu5gqWjOUdDqA4AXETQzqLPkvqLeHsagXbPoXgwaBMWgw+Au1asg6PxybfhyYPZzBfu1h5Y51uToJlCvdg5ItwDmrYtG2m0EZSqbPYWUDqhlN/uxadC8o148X4OcalBFNufRdjXuxE90HxQDqniZ/82FNvP30ssklLF8B3rIq6hDMDSbTd4AzVsUmFHOCMcjPv96hxMKdg9+GBVkVxroolgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_icon_arrow_red.png
// module id = HcNh
// module chunks = 1